import { Col, Divider, Drawer, Row, Typography } from "antd";
import dayjs from "dayjs";
import React, { useState, useEffect } from "react";
import { calculateTimeDifference } from "../../helpers/utils";
import _ from "lodash";
const { Text, Title } = Typography;

const DetailTransaction = ({
  visible,
  onClose,
  ticketDetails,
  airports,
  fareclass,
  airlines,
}) => {
  const [tickes, setTickets] = useState([]);

  useEffect(() => {
    if (ticketDetails) {
      setTickets(
        _.partition(
          ticketDetails.orderplanetickets,
          (f) =>
            f.fromairport === ticketDetails.orderplanetickets[0].fromairport
        )
      );
    }
  }, [ticketDetails]);

  const getFareClassName = (airline, fareValue) => {
    return (
      _.find(
        fareclass,
        (fare) =>
          fare.airlinecode === airline && fareValue === fare.fareclassvalue
      )?.fareclassname || fareValue
    );
  };

  return (
    <Drawer
      placement="bottom"
      onClose={onClose}
      open={visible}
      height={700}
      title="Thông tin vé"
    >
      {tickes.map((ticket) => (
        <>
          <div className="flex flex-col gap-2 p-4">
            {ticket.length > 0 && (
              <>
                <Title level={5}>
                  {
                    (airports || []).find(
                      (item) => item.code === ticket[0]?.fromairport || ""
                    )?.namevn
                  }{" "}
                  -{" "}
                  {
                    (airports || []).find(
                      (item) => item.code === ticket[0]?.toairport || ""
                    )?.namevn
                  }{" "}
                </Title>
                <div
                  className="p-4 rounded-[8px] flex flex-col gap-4"
                  style={{
                    border: "1px solid #EBEBF0",
                  }}
                >
                  <Row gutter={16} align={"middle"}>
                    <Col span={6}>
                      <img
                        src={
                          `${process.env.REACT_APP_BASE_URL}/${
                            airlines?.find(
                              (air) => air.code === ticket[0]?.airline
                            )?.iconurl
                          }` || ""
                        }
                        alt="logo"
                        style={{ width: "auto", height: 40 }}
                      />
                    </Col>
                    <Col span={6}>
                      <h4 className="font-bold text-sm">
                        {ticket[0]?.fromairport}
                      </h4>
                      <p className="text-xs">
                        {dayjs(ticket[0]?.departuretime).format(
                          "DD/MM/YYYY HH:mm:ss"
                        )}
                      </p>
                    </Col>
                    <Col span={6} className="justify-center text-center">
                      <p className="text-xs text-[#808089]">
                        {calculateTimeDifference(
                          ticket[0]?.departuretime,
                          ticket[0]?.arrivaltime
                        )}
                      </p>
                      <img src={process.env.PUBLIC_URL + '/images/flight-line.svg'} alt="" />
                      {/* <hr /> */}
                    </Col>
                    <Col span={6}>
                      <h4 className="font-bold text-sm">
                        {ticket[0]?.toairport}
                      </h4>
                      <p className="text-xs">
                        {dayjs(ticket[0]?.departuretime).format(
                          "DD/MM/YYYY HH:mm:ss"
                        )}
                      </p>
                    </Col>
                  </Row>
                </div>
              </>
            )}

            <div>
              {ticket.map((t) => (
                <div className="flex flex-col gap-2">
                  <div>
                    <Row justify="space-between">
                      <Text>Hành khách</Text>
                      <span className="font-bold text-primary">
                        {t.passengername}
                      </span>
                    </Row>{" "}
                    <Row justify="space-between">
                      <Text>Hạng vé</Text>
                      <span className="font-bold text-primary">
                        {getFareClassName(t.airline, t.fareclass)}
                      </span>
                    </Row>
                    <Row justify="space-between">
                      <Text>Mã booking | Mã vé</Text>
                      <span className="font-bold text-primary">
                        {t.bookingcode} | {t?.ticketnumber}
                      </span>
                    </Row>
                    <Divider
                      variant="dashed"
                      style={{ borderColor: "#0064D2" }}
                      dashed
                      className="my-2 py-0"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      ))}
    </Drawer>
  );
};

export default DetailTransaction;
